import { render, staticRenderFns } from "./profile-detail.component.html?vue&type=template&id=5f44fde6&scoped=true&"
import script from "./profile-detail.component.ts?vue&type=script&lang=ts&"
export * from "./profile-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./profile-detail.component.scss?vue&type=style&index=0&id=5f44fde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44fde6",
  null
  
)

export default component.exports